import Marquee from "react-fast-marquee";

const ITEMS = [
    "Traditional Wellness",
    "Marma Chikitsa",
    "Holistic Care",
    "Ayurveda-Inspired Living",
    "Kurnool, Andhra Pradesh",
];

export default function EditorialMarquee() {
    return (
        <div className="border-y border-sand/70 bg-bone py-6" data-testid="editorial-marquee" aria-hidden="true">
            <Marquee speed={28} gradient={false} pauseOnHover>
                {ITEMS.map((item, i) => (
                    <span key={i} className="mx-8 flex items-center gap-16">
                        <span className="whitespace-nowrap font-serif text-2xl italic text-forest md:text-3xl">
                            {item}
                        </span>
                        <svg viewBox="0 0 24 24" className="h-4 w-4 fill-gold">
                            <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
                        </svg>
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
